"use strict";

const { Linter } = require("./linter");
const SourceCodeFixer = require("./source-code-fixer");

module.exports = {
	Linter,

	// For testers.
	SourceCodeFixer,
};
